<template>
  <div id="LinesList">
    <SolutionsList
      :list="list"
      :view-loader="viewLoader"
      :view-error="viewError"
      :no-data-message="$t('lines.noData')"
      :colspan="7"
    >
      <template #table-headers>
        <th v-show="!$IsMobile()">{{ $t("lines.list.id") }}</th>
        <th>{{ $t("lines.list.owner") }}</th>
        <th>{{ $t("lines.list.address") }}</th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
        <th v-if="!$IsMobile()"></th>
      </template>
      <template #mobile-row="{ item }">
        <MobileCard
          :titles="['serialnumber', 'intestatario', 'solution']"
          :item="item"
          translationPath="ticketsList.lines"
        >
          <template #url-label>
            <router-link
              :to="`${$t('nav.' + detailsUrl)}/${$t('nav.detail')}/${item.id}`"
            >
              <div class="cdlButton">
                <span>
                  {{ $t("lines.details") }}
                </span>
              </div>
            </router-link>
          </template>
        </MobileCard>
      </template>
      <template #desktop-row="{ item }">
        <tr>
          <td>
            <span>
              {{ item.serialnumber }}
            </span>
          </td>
          <td>
            <span>
              {{ item.intestatario }}
            </span>
          </td>
          <td colspan="2">
            <span>
              {{ item.solution }}
            </span>
          </td>
          <td>
            <router-link
              :to="
                '/' +
                $t('nav.' + detailsUrl) +
                '/' +
                $t('nav.detail') +
                '/' +
                item.id
              "
            >
              <div class="cdlButton">{{ $t("lines.details") }}</div>
            </router-link>
          </td>
          <td colspan="3">
            <div style="display: flex">
              <HelpRequestBtn
                v-if="ctrlPerms(['incident_lista'])"
                :component-name="'ActiveLinesIncidentForm'"
                :asset-type="'lines'"
                :item-id="item.id"
                :icon="'warning'"
                :label="$t('help.incident.formTitle')"
                :skip-duplicate-warning="true"
              />

              <HelpRequestBtn
                v-if="ctrlPerms(['incident_lista'])"
                :component-name="'ActiveLinesChangeRequestForm'"
                :asset-type="'lines'"
                :item-id="item.id"
                :icon="'person'"
                :label="$t('help.changeRequest.formTitle')"
                :skip-duplicate-warning="true"
              />

              <HelpRequestBtn
                v-if="ctrlPerms(['change_request_list']) && false"
                :url="`/solutions/${$t('nav.techSupportUrl', {
                  item_id: item.id,
                  asset_type: 'lines',
                })}`"
                :icon="'settings'"
                :label="$t('help.techSupport.formTitle')"
                :skip-duplicate-warning="true"
              />
            </div>
          </td>
        </tr>
      </template>
    </SolutionsList>
  </div>
</template>

<script>
import SolutionsList from "@/components/Solutions/SolutionsList.vue";
import HelpRequestBtn from "@/components/Tables/HelpRequestBtn";
import MobileCard from "@/components/Cards/MobileCard.vue";

export default {
  name: "LinesList",
  components: {
    MobileCard,
    SolutionsList,
    HelpRequestBtn,
  },
  props: {
    detailsUrl: String,
    list: Array,
    total: Number,
    viewLoader: Boolean,
    viewError: Boolean,
  },
  methods: {
    ctrlPerms(perms) {
      return this.$ctrlPermissions(perms);
    },
  },
};
</script>
